<script>
import BaseConfig from './base-config.vue';
import { get } from 'lodash';
import { planTypes } from '@/common/constants';

export default {
  name: 'DIDEdit',
  extends: BaseConfig,
  computed: {
    decreaseTips() {
      const disableDownsell = get(window.newBillingConfig, 'downsellData.disableDownsell', false);
      const boughtPlan = this.boughtPlans.find((p) => planTypes.TOLLFREE$DID === p.type);
      if (this.selectedDIDPlan?.cartInfo?.selected_number <= boughtPlan?.cartInfo?.selected_number) {
        if (disableDownsell) {
          return this.$t('billing.error.can_not_bought_plan_tips');
        }

        return this.forNonStandardPriceTips;
      }

      return '';
    },
  }
};
</script>
